import { render, staticRenderFns } from "./EstablishmentLogo.vue?vue&type=template&id=f0c39fe6&scoped=true&lang=html&"
import script from "./EstablishmentLogo.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentLogo.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentLogo.vue?vue&type=style&index=0&id=f0c39fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c39fe6",
  null
  
)

component.options.__file = "EstablishmentLogo.vue"
export default component.exports